import { Environment } from './global';

export const eZidou: Environment = {
  app_name: 'zidou',
  app_name_real: 'zidou',
  base_url: 'https://api.zidouchat.com',
  base_url_c: 'https://api2.zidouchat.com',
  env_url: '',
  domain: 'zidouzone.com',
  bot_name: '紫豆小助手',
  app_name_string: '紫豆助手',
  app_id: 'wxbe0f84cc2b873c72',
  token_name: 'zidouUserToken',
  logo_icon_url: './assets/imgs/zidou/logo_A.png',
  logo_loader_icon: './assets/imgs/zidou-loading.gif',
  host_url: 'https://wx.zidouchat.com',
  logo_path:'/assets/imgs/zidou/logo_A.png',
  live_zidou:200,
  shareDirection:'',
  topicFlag:'',
  menu_auth_pc: [
    'statis',
    'batch_sending',
    'auto_reply',
    'sensitive',
    'sensitive-msg',
    'sensitive-list',
    'events',
    'group_zone',
    'share_task',
    'assistant',
    'staff',
    'role-list',
    'staff-list',
    'sign',
    'remote',
    'chatroom_score'
  ],
  menu_auth_wx: [
    'auto_reply',
    'batch_sending',
    'events',
    'statis',
    'sensitive',
    'group_zone',
    'share_task',
    'assistant',
    'staff',
  ],
};



// WEBPACK FOOTER //
// ./src/environments/environment.zidou.ts